import { Box, Typography } from "@mui/material";
import { toInteger } from "lodash";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { MerSETAExternalAttendeeService } from "../../../../../Component/Api/Attendee/MerSETAExternalAttendeeService";
import { MerSETALAIAttendeeService } from "../../../../../Component/Api/Attendee/MerSETALAIAttendeeService";
import { AncillaryCostService } from "../../../../../Component/Api/merSETA/AncillaryCosts/AncillaryCostsService";
import { ConfirmationDialog } from "../../../../../Component/Common/Components/ConfirmationDialog";
import AppSelectListWithInfoAndSearch from "../../../../../Component/Common/Components/FormValidationInputs/AppSelectListWithInfoAndSearch";
import { MDButton } from "../../../../../Component/Common/Components/MDButton";
import { AttendeeLookup } from "../../../../../Component/Model/Dto/WSP/Attendees/AttendeeLookup";
import { AttendeeDto } from "../../../../../Component/Model/Dto/WSP/Attendees/MerSETAAttendees";
import { SearchAncillaryCostAssociatedAttendee } from "../../../../../Component/Model/Dto/WSP/Attendees/SearchAncillaryCostAssociatedAttendee";
import { defaultObject } from "../../../../../Helpers/typescriptHelper";
import { TrainingTypes } from "../../../../../Component/Model/Enum/BEE123Enums";
import { MerSETAInternalAttendeeService } from "../../../../../Component/Api/Attendee/MerSETAInternalAttendeeService";
import { EntriesPerPage } from "../../../../../Component/Model/Table/Table";
import { AncillaryCostAttendeeTableMapper } from "./AncillaryCostAttendeeTableMapper";
import { DataTable } from "../../../../../Component/Common/Components/DataTable/DataTable";
import { ColumnSortOption } from "../../../../../Component/Model/Dto/ColumnSortOption";

interface IProps {
  interventionTypeId: number,
  organisationId: string;
  interventionId: number;
  ancillaryCostId: number;
  setHandleNextCount: (i: number) => void,
  handleNextCount: number,
  closeModal: () => void;
}

interface SelectedAttendee {
  name: string;
  platformPeopleId: string;
}

export const AncillaryCostAttendeeModal = (props: IProps) => {

  const [allAssociatedAttendee, setAllAssociatedAttendee] = useState<AttendeeDto[]>([]);
  const [allAttendees, setAllAttendees] = useState<AttendeeLookup[]>([]);
  const [selectedAttendee, setSelectedAttendee] = useState<string[]>([]);

  const [showDeleteConfirmDialog, setShowConfirmDeleteDialog] = useState<boolean>(false);
  const [selectedAttendeeToDelete, setSelectedAttendeeToDelete] = useState<SelectedAttendee>(defaultObject);
  const { control, formState: { isSubmitting } } = useForm({
    mode: 'all',
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [clearDropdownKey, setClearDropdownKey] = useState<number>(0);

  const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
  const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
  const [searchValue, setSearchValue] = useState<string>('');
  const [columnSortOptions, setColumnSortOptions] = useState<ColumnSortOption[]>([]);


  const changeSelectedAttendeeToAdd = (value: string[]) => {
    setSelectedAttendee(value);
  }

  const entriesPerPageChanged = (entriesPerPage: number) => {
    setEntriesPerPage({ defaultValue: entriesPerPage });
    setPageNumber(1);
}

const pageNumberChanged = (pageNumber: number) => {
    setPageNumber(pageNumber);
}

const searchValueChanged = (value: string) => {
    setSearchValue(value);
}

const columnSortingChanged = (sortOption: ColumnSortOption) => {
  setColumnSortOptions([sortOption]);
  setPageNumber(1);
}

const getAssociatedAttendees = async () => {
  try {
    setIsLoading(true);
    let attendeeSearchRequest: SearchAncillaryCostAssociatedAttendee = ({
      pageNumber: pageNumber,
      pageSize: entriesPerPage.defaultValue!,
      searchValue: searchValue,
      ancillaryCostId: props.ancillaryCostId,
      interventionId: props.interventionId,
      interventionTypeId: props.interventionTypeId
    });
    let attendeeResult = await AncillaryCostService.GetAssociatedAttendee(attendeeSearchRequest);
    setAllAssociatedAttendee(attendeeResult.data.results);
    setFilteredItemsCount(attendeeResult.data.filteredItemsCount);
    setTotalItemsCount(attendeeResult.data.totalItemsCount);
  } catch (error) {
    console.error(error);
  }finally{
    getAllAttendees()
    setIsLoading(false);
  }
};

  const getAllAttendees = async () => {
      try {
        setIsLoading(true);
        let attendeeResult;
        if (props.interventionTypeId === TrainingTypes.LAI) {
          attendeeResult = await MerSETALAIAttendeeService.getAllAllocatedAttendees(toInteger(props.organisationId), props.interventionId, props.ancillaryCostId);
        } else if (props.interventionTypeId === TrainingTypes.External) {
          attendeeResult = await MerSETAExternalAttendeeService.getAllAllocatedAttendees(toInteger(props.organisationId), props.interventionId, props.ancillaryCostId);
        } else if (props.interventionTypeId === TrainingTypes.Internal) {
          attendeeResult = await MerSETAInternalAttendeeService.getAllAllocatedAttendees(toInteger(props.organisationId), props.interventionId, props.ancillaryCostId);
        }
        setAllAttendees(attendeeResult?.data ?? defaultObject);
          } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    }
  

  const handleDeleteAttendee = async () => {
    try {
      await AncillaryCostService.DeleteAssociatedAttendee(props.ancillaryCostId, selectedAttendeeToDelete?.platformPeopleId, props.interventionId, props.interventionTypeId);
      toast.success(`${selectedAttendeeToDelete.name} has been deleted`);
      setShowConfirmDeleteDialog(false);
      if(allAssociatedAttendee.length <= 1)
      {
        setPageNumber (pageNumber-1) 
      }
      await getAssociatedAttendees();
        }
    catch (err) {
      toast.error("Attendee could not be deleted")
    }
  }

  const showDeleteAttendeeConfirmation = async (id: string, name: string) => {
    setSelectedAttendeeToDelete({ platformPeopleId: id, name: name });
    setShowConfirmDeleteDialog(true);
  }

  const AssociateAttendee = async () => {
    if (selectedAttendee.length !== 0) {
      try {
        setIsLoading(true)
        await AncillaryCostService.AssociateAttendee(selectedAttendee, props.ancillaryCostId, props.interventionId, props.interventionTypeId);
        setAllAttendees(allAttendees.filter(attendee => !selectedAttendee.includes(attendee.platformPeopleId)))
        toast.success(selectedAttendee.length  + (selectedAttendee.length  > 1 ? ' Attendees' : ' Attendee') + ' have been added.');
        setSelectedAttendee([]);
        getAssociatedAttendees();
      }
      catch {
        toast.error("Failed to capture Attendee")
      } finally {
        setIsLoading(false)
      }
    }
    else {
      toast.error('No attendee has been selected to be added');
      return;
    }
  };

  useEffect(() => {
     getAssociatedAttendees()
  }, [entriesPerPage, pageNumber, columnSortOptions, searchValue]);


  const ancillarycostAttendeeTable = AncillaryCostAttendeeTableMapper(
    allAssociatedAttendee,
    showDeleteAttendeeConfirmation
);

  return (
    <>
      <Typography variant="body2" style={{ paddingBottom: "10px" }}>
        Associate attendees to this ancillary cost.
      </Typography>
      <AppSelectListWithInfoAndSearch
        key={clearDropdownKey}
        control={control}
        name="attendee"
        label="Attendees"
        size="small"
        options={allAttendees}
        onChange={(value: string[]) => changeSelectedAttendeeToAdd(value)}
        onAdd={() => AssociateAttendee()}
        isAncillaryCost={true}
      />
      <DataTable
          key={totalItemsCount}
          table={ancillarycostAttendeeTable}
          entriesPerPage={entriesPerPage}
          pageNumber={pageNumber}
          filteredItemsCount={filteredItemsCount}
          totalItemsCount={totalItemsCount}
          entriesPerPageChanged={entriesPerPageChanged}
          pageNumberChanged={pageNumberChanged}
          isLoading={isLoading}
          manualSorting={true}
          columnSortingChanged={columnSortingChanged}
          canSearch={true}
          searchValueChanged={searchValueChanged}
      ></DataTable>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: -1, mt: 2 }}>
        <MDButton
          variant="outlined"
          color="primary"
          sx={{ mr: 2, mt: 2 }}
          onClick={() => props.setHandleNextCount(props.handleNextCount - 1)}
        >
          Back
        </MDButton>
      </Box>
      <ConfirmationDialog
        showDialog={showDeleteConfirmDialog}
        handleAccept={handleDeleteAttendee}
        handleCancel={() => { setShowConfirmDeleteDialog(false) }}
        heading={"Confirm Delete"}
        message={`Are you sure you want to delete ${selectedAttendeeToDelete.name} ?`}
      />
    </>
  )
}

